import { motion } from "framer-motion";
import { Building2 } from "lucide-react";
import { CLIENTS } from "@/data/site";
import { Reveal } from "@/lib/motionPrimitives";

export default function Clients() {
  return (
    <section id="clients" className="relative py-24 md:py-32" data-testid="clients">
      <div className="container-x">
        <Reveal className="text-center">
          <p className="overline">Trusted By</p>
          <h2 className="mt-4 font-display text-3xl sm:text-4xl lg:text-5xl font-bold tracking-tight">
            Our Clients
          </h2>
          <p className="mx-auto mt-4 max-w-lg text-muted-foreground">
            Delivering durable protection for respected industrial names.
          </p>
        </Reveal>

        <div className="mx-auto mt-14 grid max-w-3xl gap-6 sm:grid-cols-2">
          {CLIENTS.map((c, i) => (
            <motion.div
              key={c.name}
              initial={{ opacity: 0, y: 24 }}
              whileInView={{ opacity: 1, y: 0 }}
              viewport={{ once: true }}
              transition={{ delay: i * 0.1, duration: 0.6 }}
              data-testid={`client-${i}`}
              className="group flex flex-col items-center gap-4 rounded-3xl border border-border bg-surface p-10 text-center transition-colors hover:border-primary"
            >
              <span className="flex h-14 w-14 items-center justify-center rounded-2xl bg-primary/10 text-primary transition-colors group-hover:bg-primary group-hover:text-primary-foreground">
                <Building2 className="h-7 w-7" />
              </span>
              <div>
                <h3 className="font-display text-xl font-bold tracking-tight">{c.name}</h3>
                {c.sub && <p className="mt-1 text-sm text-muted-foreground">{c.sub}</p>}
              </div>
            </motion.div>
          ))}
        </div>
      </div>
    </section>
  );
}
